import React from 'react';
import i18next from 'i18next';

import { IPayout } from 'types';
import { currency } from 'globals/currency';
import Shapes from 'shapes/main';
import { formatDate } from 'utils/date-time';

interface IProps {
  payout: IPayout;
}

export const getPayoutPaidAtLabel = (payout: IPayout) => {
  if (payout.paid_at) {
    return formatDate(new Date(payout.paid_at));
  }
  if (new Date(payout.created_at) >= new Date('2023-01-01')) {
    if (payout.sum_to_payout === 0) {
      return i18next.t('payout-item.empty-period');
    }
    return payout.sum_to_payout > 0
      ? i18next.t('payout-item.awaiting-settlement')
      : i18next.t('payout-item.awaiting-deduction');
  }
  return i18next.t('payout-item.no-info');
};

const PayoutItem: React.FC<IProps> = ({ payout }) => {
  return (
    <>
      <div>{i18next.t('payout-item.orders-turnover')}</div>
      <div>
        {i18next.t('payout-item.all')}: {payout.orders_sum_all} {currency}
      </div>
      <div>
        {i18next.t('payout-item.paid-online')}: {payout.orders_sum_online} {currency}
      </div>
      <div>
        {i18next.t('payout-item.paid-on-delivery')}: {payout.orders_sum_offline} {currency}
      </div>
      <hr />
      <div>
        {i18next.t('payout-item.commission-net')}: {payout.commission_net} {currency}
      </div>
      <div>
        {i18next.t('payout-item.commission-gross')}: {payout.commission_brut} {currency}
      </div>
      <div>
        {i18next.t('payout-item.promo-codes-cost')}: {payout.promo_codes_cost} {currency}
      </div>
      <hr />
      <div>
        {i18next.t('payout-item.amount-to-pay')}: {payout.sum_to_payout} {currency}
      </div>
      <div>{i18next.t('payout-item.transfer-date')}: {getPayoutPaidAtLabel(payout)}</div>
    </>
  );
};

PayoutItem.propTypes = {
  payout: Shapes.payoutShape.isRequired,
};

export default PayoutItem;
